import { Component, HostBinding, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonButton } from '@ionic/angular/standalone';

@Component({
  selector: 'crowdctrl-button',
  standalone: true,
  imports: [IonButton, RouterLink],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
})
export class ButtonComponent {
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() expand?: 'block' | 'full';
  @Input() fill?: 'clear' | 'outline' | 'solid' | 'default';
  @Input() color?: string;
  @Input() size?: 'small' | 'default' | 'large';
  @Input() shape?: 'round';
  @Input() strong?: boolean;

  @Input() routerLink?: string | any[];
  @Input() routerDirection?: 'forward' | 'back' | 'root';
  @Input() href?: string;
  @Input() target?: string;
  @Input() download?: string;
  @Input() rel?: string;

  @HostBinding('class.expand-block')
  get hasExpandBlock(): boolean {
    return this.expand === 'block';
  }
}
